import {
	ClientInsuredPersonRiskVariantEnum,
	type ClientPortfolioInsuredPersonRequestDTO,
	type InsuredPersonDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	InsuredPersonInput,
	InsuredPersonOutput,
} from "web_myplann/Portfolio/Forms/LifeInsuranceForm/InsuredPersons/insuredPersonSchema";

export const mapInsuredPersonsToForm = (
	insuredPersons: InsuredPersonDTO[] | null | undefined,
): InsuredPersonInput[] =>
	(insuredPersons ?? []).map((person) => ({
		id: person.id,
		firstname: person.firstname ?? "",
		lastname: person.lastname ?? "",
		identificationNumber: person.identificationNumber ?? "",
		risks: (person.risks ?? []).map((risk) => ({
			id: risk.id,
			risk: risk.risk,
			value: risk.value ?? null,
			toAge: risk.toAge ?? null,
			variant:
				risk.variant === ClientInsuredPersonRiskVariantEnum.Empty
					? null
					: (risk.variant ?? null),
			additionalInfo: risk.additionalInfo ?? null,
		})),
	}));

export const mapInsuredPersonsToRequest = (
	insuredPersons: InsuredPersonOutput[],
): ClientPortfolioInsuredPersonRequestDTO[] =>
	insuredPersons.map((person) => ({
		id: person.id,
		firstname: person.firstname,
		lastname: person.lastname,
		identificationNumber: person.identificationNumber,
		risks: person.risks.map((risk) => ({
			id: risk.id,
			risk: risk.risk,
			value: risk.value,
			toAge: risk.toAge,
			variant: risk.variant,
			additionalInfo: risk.additionalInfo,
		})),
	}));
